/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'undefinedValue',
    standalone: false
})
export class UndefinedValuePipe implements PipeTransform {

    transform(value: any): string {
        return value !== undefined && value !== null && value !== '' ? value : '-';
    }
}
